import { Injectable, Pipe, PipeTransform } from "@angular/core";

export interface ISplitPascalCaseParams {
    ignoreDigits?: boolean;
}

@Pipe({ name: 'splitPascalCase' })
@Injectable()
export class SplitPascalCasePipe implements PipeTransform {
    constructor() { }

    transform(input: string, params?: ISplitPascalCaseParams): string {
        if (params?.ignoreDigits) {
            return (!!input)
                ? input.replace(/([A-Z][a-z])/g, " $1").trim()
                : "";
        }

        return (!!input)
            ? input.replace(/([A-Z][a-z])/g, " $1").replace(/(\d)/g, " $1").trim()
            : "";
    }
}
